import type { FC, ReactNode } from "react";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { SplashScreen } from "src/components/splash-screen";
import {
  useOnboardingState,
  UPGRADE_REDIRECTED_KEY,
} from "src/hooks/use-onboarding-state";

interface OnboardingGuardProps {
  children: ReactNode;
}

export const OnboardingGuard: FC<OnboardingGuardProps> = ({ children }) => {
  const router = useRouter();
  const state = useOnboardingState();

  if (state.status === "loading") {
    return <SplashScreen />;
  }

  // AuthGuard above us handles unauthenticated/unverified — but if the hook
  // returns those states anyway, don't redirect-loop; just pass through and let
  // AuthGuard deal with it on its next cycle.
  if (state.status === "unauthenticated" || state.status === "unverified") {
    return <>{children}</>;
  }

  if (state.status === "no_pro_group") {
    router.replace(paths.getStarted.index);
    return <SplashScreen />;
  }

  if (state.status === "unpaid") {
    router.replace(paths.getStarted.index);
    return <SplashScreen />;
  }

  if (state.status === "paid_unboarded") {
    const alreadyRedirected = sessionStorage.getItem(UPGRADE_REDIRECTED_KEY) === "true";
    if (alreadyRedirected) {
      return <>{children}</>;
    }
    sessionStorage.setItem(UPGRADE_REDIRECTED_KEY, "true");
    router.replace(paths.dashboard.upgrade);
    return <SplashScreen />;
  }

  // onboarded (or self-serve already on /upgrade) — allow through
  return <>{children}</>;
};
